import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useSnackbar } from '@/features/snackbar';

import { mutationFn } from './mutationFn';
import { getQueryKey as narrativeGetQueryKey } from '@/pages/Narrative/hooks/useNarrative/useNarrative';

type Options = {
  narrativeSlug: string;
  onSuccess?: (data: { id: string }) => void;
};

export const useUpdateNarrative = (options: Options) => {
  const queryClient = useQueryClient();
  const { addSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: mutationFn,
    onSuccess: (data) => {
      addSnackbar({
        type: 'positive',
        lifeTime: 1000,
        message: 'Narrative successfully updated',
      });
      options.onSuccess?.(data);
    },
    onError: () => {
      addSnackbar({
        type: 'negative',
        lifeTime: 2000,
        message: 'Failed to update narrative',
      });
    },
    onSettled: () => {
      const NARRATIVE_QUERY_KEY = narrativeGetQueryKey(options.narrativeSlug);

      queryClient.invalidateQueries({ queryKey: NARRATIVE_QUERY_KEY });
    },
  });
};
